import { Center, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import React from "react";

const partners = [
  "/assets/institutions/investments/bankless.svg",
  "/assets/institutions/investments/hypersphere.svg",
  "/assets/institutions/investments/draper.svg",
  "/assets/institutions/investments/dacm.svg",
  "/assets/institutions/investments/cypher.svg",
  "/assets/institutions/investments/arkstream.svg",
  "/assets/institutions/investments/cluster.svg",
  "/assets/institutions/investments/gsr.svg",
  "/assets/institutions/investments/longhash.svg",
  "/assets/institutions/investments/sidedoor.svg",
  "/assets/institutions/investments/noia.svg",
  "/assets/institutions/investments/htx.svg",
  "/assets/institutions/investments/avid.svg",
  "/assets/institutions/investments/via-btc.svg",
  "/assets/institutions/investments/dwf-labs.svg",
  "/assets/institutions/investments/coinseeker.svg",
  "/assets/landingPage/partners/funds/tulipa.svg",
  "/assets/institutions/investments/many-others-text.svg",
];

const Investments = () => {
  return (
    <Center
      flexDir={"column"}
      maxWidth="1512px"
      w="100%"
      px={{ base: 5, md: 20 }}
      py={20}
    >
      <Center maxW={492} flexDir={"column"}>
        <Text
          fontSize={40}
          lineHeight={"48px"}
          fontWeight={500}
          textAlign="center"
        >
          $9M+ raised from top tier funds & angels
        </Text>
        <Text
          fontSize={20}
          lineHeight={6}
          fontWeight={500}
          mt={3}
          textAlign="center"
        >
          Kelp&apos;s vision is supported by the best in the business.
        </Text>
      </Center>
      <Center mt="72px" maxW={928} flexDir={"column"}>
        <Flex alignItems={"center"} gap={"38px"}>
          <BaseImage
            src="/assets/institutions/investments/scb.svg"
            width={85}
            height={71}
            alt="scb"
          />
          <BaseImage
            src="/assets/institutions/investments/laser-digital.svg"
            width={240}
            height={60}
            alt="scb"
          />
        </Flex>
      </Center>
      <Grid
        w={{ base: "100%", md: 928 }}
        mt={12}
        templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(6, 1fr)" }}
        gap={{ base: 2, md: 6 }}
        rowGap={7}
      >
        {partners.map((partner) => (
          <GridItem
            w="100%"
            key={partner}
            display={"flex"}
            justifyContent={"center"}
          >
            <BaseImage src={partner} alt="partner" width={117} height={22} />
          </GridItem>
        ))}
      </Grid>
    </Center>
  );
};

export default Investments;
